module.exports = __webpack_public_path__ + "static/media/PRIV.00025654.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/QuotePage/TransferOptionsPanel/images/PRIV.svg
// module id = 860
// module chunks = 0